// extracted by mini-css-extract-plugin
export const contactinfo = "contactinfo-module--contactinfo--1F88-";
export const inverted = "contactinfo-module--inverted--2VUsQ";